import atomsSettings from './atoms/settings';
import moleculesSettings from './molecules/settings';
import organismsSettings from './organisms/settings';

const componentsSettings = {
  ...atomsSettings,
  ...moleculesSettings,
  ...organismsSettings,
};

export default componentsSettings;
